import reportFilename from "../reportFilename";
import buildAcrJsonModel from "./buildAcrJsonModel";
import buildAcrYamlModel from "./buildAcrYamlModel";
import buildAcrHtmlString from "./buildAcrHtmlString";
import serializeAcrYaml from "./serializeAcrYaml";

/**
 * Build the { filename, content } for a single ACR export in the given format. Kept as the one place
 * that turns an evaluation + catalog into file bytes so single-file downloads and the bulk zip
 * export stay identical. Content matches the standalone downloadAcr{Json,Yaml,Html} utilities.
 */
export default function buildAcrFileContent(evaluation, catalog, fileType) {
  const base = reportFilename(evaluation);

  if (fileType === "json") {
    return {
      filename: `${base}.json`,
      content: `${JSON.stringify(buildAcrJsonModel(evaluation, catalog), null, 2)}\n`,
    };
  }

  if (fileType === "yaml") {
    return {
      filename: `${base}.yaml`,
      content: `${serializeAcrYaml(buildAcrYamlModel(evaluation, catalog))}\n`,
    };
  }

  return {
    filename: `${base}.html`,
    content: buildAcrHtmlString(evaluation, catalog),
  };
}
